import { Address, AddressValue, BigUIntValue, ContractFunction, StringValue, TokenIdentifierValue, Transaction, TransactionPayload, U64Value } from '@multiversx/sdk-core/out';
import { sendTransactions } from '@multiversx/sdk-dapp/services';
import { refreshAccount } from '@multiversx/sdk-dapp/utils';
import { LEND_GAS_LIMIT, JEWEL_LEND_V2_SC_ADDRESS } from 'config';

export const sendJewelLend = async (chainID: string, address: string, lendTokenId: string, lendAmount: string) => {
  let tx: any = {};
  if (lendTokenId == 'EGLD') {
    tx = new Transaction({
      value: lendAmount,
      sender: new Address(address),
      receiver: new Address(JEWEL_LEND_V2_SC_ADDRESS),
      gasLimit: LEND_GAS_LIMIT,
      chainID: chainID,
      data: new TransactionPayload('lendEgld'),
    });
  } else {
    const data = TransactionPayload.contractCall()
      .setFunction(new ContractFunction('ESDTTransfer'))
      .addArg(new TokenIdentifierValue(lendTokenId))
      .addArg(new BigUIntValue(lendAmount))
      .addArg(new StringValue('lenderDeposit'))
      .build();

    tx = new Transaction({
      value: '0',
      sender: new Address(address),
      receiver: new Address(JEWEL_LEND_V2_SC_ADDRESS),
      gasLimit: LEND_GAS_LIMIT,
      chainID: chainID,
      data,
    });
  }

  await refreshAccount();
  await sendTransactions({
    transactions: tx,
    transactionsDisplayInfo: {
      processingMessage: 'Processing Lend Request',
      errorMessage: 'Error occured during Lend Request',
      successMessage: 'Lend Request Successful',
    }
  });
};

export const sendJewelWithdraw = async (chainID: string, address: string, ibTokenId: string, ibTokenAmount: string) => {
  const data = TransactionPayload.contractCall()
      .setFunction(new ContractFunction('ESDTTransfer'))
      .addArg(new TokenIdentifierValue(ibTokenId))
      .addArg(new BigUIntValue(ibTokenAmount))
      .addArg(new StringValue('lenderWithdraw'))
      .build();

  const tx = new Transaction({
    value: '0',
    sender: new Address(address),
    receiver: new Address(JEWEL_LEND_V2_SC_ADDRESS),
    gasLimit: LEND_GAS_LIMIT,
    chainID: chainID,
    data,
  });

  await refreshAccount();
  await sendTransactions({
    transactions: tx,
    transactionsDisplayInfo: {
      processingMessage: 'Processing Withdraw Request',
      errorMessage: 'Error occured during Withdraw Request',
      successMessage: 'Withdraw Request Successful',
    }
  });
};